




import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import StudentCategoriesForm from "@/views/Configuration/StudentCategories/StudentCategoriesForm.vue";
import { IStudentCategory } from "@/interfaces/IStudentCategory";

@Component({
  components: {
    FscSimpleCard,
    StudentCategoriesForm,
  },
})
export default class StudentCategoriesEdit extends Vue {
  public name = "StudentCategoriesEdit";

  @Prop()
  selectedCategory!: any;

  @Prop({ type: Boolean, required: false, default: () => false })
  public isLoading!: boolean;

  public category: IStudentCategory | null = null;

  public onStudentCategoryUpdate(category: IStudentCategory): void {
    this.$emit("category-update", category);
  }

  public onStudentCategoryAbortUpdate(): void {
    this.$emit("update-abort");
  }

  @Watch("selectedCategory", { immediate: true, deep: true })
  public onSelectedCategoryChange(category: any): void {
    if (category) {
      this.category = category;
    }
  }
}
